import { callWrapper } from './utils';
import axios from 'axios';
import users from './entities/users';
import jsr from './entities/jsr';
import pages from 'api/entities/pages';

axios.defaults.headers.post = {
    'Content-Type': 'application/json',
};

const queryString = (query) => new URLSearchParams(query).toString();

const api = {
    auth: {
        azure: {
            login: callWrapper((data) =>
                axios.post('/api/auth/azure-login', data)
            ),
            register: callWrapper((data) =>
                axios.post('/api/auth/register-azure-account', data)
            ),
        },
        saas: {
            login: callWrapper((data) =>
                axios.post('/api/auth/saas-login', data)
            ),
        },
        valpakSSO: {
            loginUrl: callWrapper(() => axios.get('/api/auth/valpak-sso-url')),
            redirectUrl: callWrapper((redirectUrl) =>
                axios.get(
                    `/api/auth/valpak-redirect-url?redirecturl=${redirectUrl}`
                )
            ),
        },
        qlik: callWrapper(() => axios.post('/api/users/qlik-jwt-sso')),
    },
    forms: {
        all: callWrapper(() => axios.get('/api/forms')),
        get: callWrapper((id) => axios.get(`/api/forms/${id}`)),
        reload: callWrapper((id) => axios.post(`/api/forms/${id}/reload`)),
        create: callWrapper((data) => axios.post('/api/forms', data)),
        clone: callWrapper((id) => axios.post(`/api/forms/${id}/clone`)),
        update: callWrapper((id, data) => axios.put(`/api/forms/${id}`, data)),
        delete: callWrapper((id) => axios.delete(`/api/forms/${id}`)),
        createFormContent: callWrapper((formId, data) =>
            axios.post(`/api/forms/${formId}/form-content`, data)
        ),
        getLastEntry: callWrapper((id) =>
            axios.get(`/api/forms/${id}/last-entry`)
        ),
        getByGroup: callWrapper((groupId) =>
            axios.get(`/api/forms/groups/${groupId}`)
        ),
    },
    objects: {
        get: callWrapper((id) => axios.get(`/api/objects/${id}`)),
        create: callWrapper((pageId, data) =>
            axios.post(`/api/pages/objects/${pageId}`, data)
        ),
    },
    settings: {
        getApiKey: callWrapper(() => axios.get(`/api/settings/api-key`)),
        setApiKey: callWrapper((data) =>
            axios.post(`/api/settings/api-key`, data)
        ),
    },
    groups: {
        addResource: callWrapper((groupId, resource) =>
            axios.post(`/api/groups/resources/${groupId}`, resource)
        ),
        removeResource: callWrapper((type, groupId, resourceId) =>
            axios.delete(
                `/api/groups/resources/${type}/${groupId}/${resourceId}`
            )
        ),
    },
    users,
    jsr,
    qlik: {
        connect: callWrapper((data) => axios.post(`/api/qlik/connect`, data)),
    },
    pages,
};

export default api;
